import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Sidebar from '../components/navigation/Sidebar';
import SelectMachine from '../components/calculator/SelectMachineView';
import SelectMaterialView from '../components/calculator/SelectMaterialView';
import SelectDesignView from '../components/calculator/SelectDesignView';
import SelectElectricityCostView from '../components/calculator/SelectElectricityCostView';
import SelectWorkerCostView from '../components/calculator/SelectWorkerCostView';
import SelectPriceView from '../components/calculator/SelectPriceView';
import SelectResultsView from '../components/calculator/SelectResultsView';
import Consumptions from '../api/consumptions';

const Home = ({
  view,
  showSidebar,
}) => {
  const [showView, setShowView] = useState(<SelectMachine />);
  const [homeTariff, setHomeTariff] = useState([]);

  const selectView = () => {
    switch (view) {
      case 1:
        setShowView(<SelectMachine />);
        break;
      case 2:
        setShowView(<SelectMaterialView />);
        break;
      case 3:
        setShowView(<SelectDesignView />);
        break;
      case 4:
        setShowView(<SelectElectricityCostView homeTariff={homeTariff} />);
        break;
      case 5:
        setShowView(<SelectWorkerCostView />);
        break;
      case 6:
        setShowView(<SelectPriceView />);
        break;
      case 7:
        setShowView(<SelectResultsView />);
        break;
      default:
        setShowView(showView);
        break;
    }
  };

  const handleClick = (e) => {
    if (!document.getElementById('sidebar').contains(e.target) && e.target?.id !== 'sidebar-handler') {
      document.querySelector('aside').classList.add('disappear-bar');
    }
  };

  useEffect(() => {
    selectView();
  }, [view]);

  useEffect(async () => {
    // trae todas las tarifas de HOGAR que marca la cfe
    await Consumptions.getRates('HOGAR')
      .then((response) => {
        setHomeTariff(response?.tarifas);
      })
      .catch((err) => err);
  }, []);

  return (
    <div
      role="presentation"
      onClick={(e) => (window.outerWidth < 501 && showSidebar) && handleClick(e)}
      className="home"
    >
      <Sidebar />
      {showView}
    </div>
  );
};

Home.propTypes = {
  view: PropTypes.number.isRequired,
  showSidebar: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => (
  {
    view: state.view,
    showSidebar: state.showSidebar,
  });

export default connect(mapStateToProps, null)(Home);
